import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../login/AuthProvider";
import { point } from "../../components/apipath";
import "./styles/point.scss";
import Swal from 'sweetalert2';

function PointRequestForm() {
    
    const { token, mem_id, mem_status, authorized } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!authorized || String(mem_status) !== "1") {
            Swal.fire({
                icon: 'warning',
                title: '學員專屬功能',
                text: '此頁面僅限學員使用，請先完成購買',
                confirmButtonText: '了解',
                confirmButtonColor: '#224040',
            }).then(() => {
                navigate('/');
            });
        }
    }, []);

    const [formData, setFormData] = useState({
        mem_id: mem_id,
        core_subjects: [],
        specialty: "",
        core_subject: [],
        // remittance_date: "",
        // remittance_last5: "",
        e_material: false,
        requested_points: 0,
    });
    const [coursePoints, setCoursePoints] = useState([]);
    // const [totalPoints, setTotalPoints] = useState(0);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    
    useEffect(() => {
        const fetchCoursePoints = async () => {
            try {
                const response = await axios.get(`${point}course-points`);
                if (response.data.status === 200) {
                    // console.log("Fetched Course Points:", response.data.data);
                    setCoursePoints(response.data.data);
                }
            } catch (error) {
                console.error("Error fetching course points:", error);
            }
        };
        fetchCoursePoints();
    }, []);

    // const handleChange = (e) => {
    //     const { name, value, checked, type } = e.target;
    //     setFormData({
    //         ...formData,
    //         [name]: type === "checkbox" ? checked : value,
    //     });
    // };
    const handleCheckboxChange = (e) => {
        const { value, checked } = e.target;
        setFormData((prevData) => {
            const updatedSubjects = checked
                ? [...prevData.core_subjects, value]
                : prevData.core_subjects.filter((subject) => subject !== value);
    
            const updatedCoreSubject = [...updatedSubjects, prevData.specialty].filter(Boolean);
    
            return {
                ...prevData,
                core_subjects: updatedSubjects,
                core_subject: updatedCoreSubject,
                requested_points: calculateTotalPoints(updatedCoreSubject),
            };
        });
    };
    
    
    const handleRadioChange = (e) => {
        const { name, value } = e.target;
    
        setFormData((prevData) => {
            let updatedCoreSubject = prevData.core_subject;
    
            if (name === "specialty") {
                updatedCoreSubject = [...(prevData.core_subjects || []), value].filter(Boolean);
            }
    
            return {
                ...prevData,
                [name]: name === "e_material" ? value === "true" : value, 
                core_subject: updatedCoreSubject,
                requested_points: calculateTotalPoints(updatedCoreSubject),
            };
        });
    };
    
    

    const calculateTotalPoints = (selectedCourses) => {
        return selectedCourses.reduce((total, course) => {
            const matchedCourse = coursePoints.find((c) => c.course_name === course);
            return total + (matchedCourse ? matchedCourse.points : 0);
        }, 0);
    };
    
    


    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSuccessMessage("");
    
        try {
            const dataToSend = {
                mem_id: mem_id || "", 
                timestamp: Date.now(),
                core_subject: Array.isArray(formData.core_subject) ? formData.core_subject.join(",") : formData.core_subject,
                // remittance_date: formData.remittance_date,
                // remittance_last5: formData.remittance_last5,
                e_material: formData.e_material,
                requested_points: parseInt(formData.requested_points, 10),
                remaining_points_after: formData.remaining_points_after || "",
                status: "審核中",
                remarks: formData.remarks || "",
                memo: formData.memo || ""
            };
    
            // console.log("Data to Send:", dataToSend); // 調試輸出
            
            const response = await axios.post(`${point}`, dataToSend, { headers: { token } });
    
            if (response.data.status === 200) {
                setSuccessMessage("申請成功！請等待管理員審核。");
                Swal.fire({
                    icon: 'success',
                    title: '申請成功',
                    text: '請等待管理員審核！',
                    confirmButtonText: '確認'
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: '提交失敗',
                    text: response.data.msg || '提交失敗，請稍後再試。',
                    confirmButtonText: '確認'
                });
            }
        } catch (error) {
            console.error("Error submitting request:", error);
            Swal.fire({
                icon: 'error',
                title: '伺服器錯誤',
                text: '提交失敗，請稍後再試。',
                confirmButtonText: '確認'
            });
        }
    
        setIsSubmitting(false);
    };
    

    return (
        <>
            <div className="container">
                <div className="banner mt100">
                    <img src="/memberImg/548_photo_96289.png" alt="點數申請" />
                </div>
                <p className="mt-3"><strong>好消息！</strong> Becker Taiwan 自 2021 年起，提供學員於雲端觀看當期最新中文課程影片，期望能夠更有效率地協助全球華人考生通過考試。</p>
                <h3 className="font-weight-bold mt-5 pb-3 ">影片上架時間點</h3>
                <p>每堂面授課皆有錄影，課後一週內上架至 Becker Taiwan 中文雲端教室，供補課或隨時隨地觀看。</p>
                {/* <p>各科目面授時間與影片上架時程，請參考最新的 <a href="https://beckertw.com/art/606" target="_blank" rel="noopener noreferrer">課表公告</a>。</p> */}
                <p>請留意各期課程適用的教材版本，例：第 52 期中文課程使用 2025年考試的教材版本。</p>

                <h3 className="font-weight-bold mt-5 pb-3">影片開放時間</h3>
                <p>自影片上架日起，可觀看至該科目面授結束後半年（若該科目有新一期面授，則影片將提早被新課程取代）。</p>

                <h3 className="font-weight-bold mt-5 pb-3">點數看課機制</h3>
                <ul>
                    <li><strong>為什麼需要申請點數？</strong>  
                        部分學員選擇實體面授 / 數位學習，上課時數皆從個人總額度扣除。
                    </li>
                    <li><strong>線上看課扣點機制：</strong>  
                        每堂課需使用 1 個點數觀看，點數一旦獲得，將直接從個人額度中扣除，無法取消或加回時數。
                    </li>
                    <li><strong>平台扣點與觀看方式：</strong>  
                        扣點進入觀看後，可於「該堂課影片總時長 + 60 分鐘」內觀看，期間可暫停、倒帶、不重複扣點。
                    </li>
                </ul>

                <h3 className="font-weight-bold mt-5 pb-3">所需點數額度</h3>
                <p>2025 上半年最新中文課程各科點數需求：</p>
                {coursePoints.length > 0 ? (
                    <ul className="info-list">
                        {coursePoints.map((course, index) => (
                            <li key={index}>
                                <strong>{course.course_name}：</strong> {course.points} 堂（{course.points} 點）
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p>載入中...</p>
                )}

                <h3 className="font-weight-bold mt-5 pb-3">版權與使用規範</h3>
                <p>Becker Taiwan 影片包含美國 Becker 原版教材，受美國著作權法保護。學員應遵守服務政策，嚴禁轉售、轉贈、轉讓及分享，違者將依法處理。</p>

                <h3 className="font-weight-bold mt-5 pb-3">特殊狀況提醒</h3>
                <p>請提前申請准考證，以確保報考時間。若遇 NASBA 延遲回應，可聯絡我們協助處理。</p>

                <h3 className="font-weight-bold mt-5 pb-3">平台疑難排解</h3>
                <p>若有任何問題，請聯絡 <a href="https://line.me/R/ti/p/%40vtz1908l" target="_blank" rel="noopener noreferrer">客服 LINE 帳號</a>。</p>
            </div>
            <div className="container mb100 mt100">
                <div className="beckertitlename mt100 mb-5">點數申請</div>
                <div className="card w-75 p-5 m-auto">
                    <div className="card-body">
                        {successMessage && <div className="alert alert-success">{successMessage}</div>}

                        <form onSubmit={handleSubmit}>
                            {/* 學科 */}
                            <div className="form-group mb-4">
                                <label className="mb-2">*學科（可多選）</label>
                                <div className="checkbox-group">
                                    <label className="checkbox-inline me-3">
                                        <input type="checkbox" value="FAR" checked={formData.core_subjects.includes("FAR")} onChange={handleCheckboxChange} /> FAR
                                    </label>
                                    <label className="checkbox-inline me-3">
                                        <input type="checkbox" value="REG" checked={formData.core_subjects.includes("REG")} onChange={handleCheckboxChange} /> REG
                                    </label>
                                    <label className="checkbox-inline me-3">
                                        <input type="checkbox" value="AUD" checked={formData.core_subjects.includes("AUD")} onChange={handleCheckboxChange} /> AUD
                                    </label>
                                </div>
                            </div>

                            {/* 專科 */}
                            <div className="form-group mb-4">
                                <label className="mb-2">*專科（單選）</label>
                                <div className="radio-group">
                                    <label className="radio-inline me-3">
                                        <input type="radio" name="specialty" value="TCP" checked={formData.specialty === "TCP"} onChange={handleRadioChange} /> TCP
                                    </label>
                                    <label className="radio-inline me-3">
                                        <input type="radio" name="specialty" value="BAR" checked={formData.specialty === "BAR"} onChange={handleRadioChange} /> BAR
                                    </label>
                                    <label className="radio-inline me-3">
                                        <input type="radio" name="specialty" value="ISC" checked={formData.specialty === "ISC"} onChange={handleRadioChange} /> ISC
                                    </label>
                                </div>
                            </div>

                            {/* 電子講義 */}
                            <div className="form-group mb-4">
                                <label className="mb-2">*是否領取電子講義</label>
                                <div className="radio-group">
                                    <label className="radio-inline me-3">
                                        <input
                                            type="radio"
                                            name="e_material"
                                            value="true"
                                            checked={formData.e_material === true}
                                            onChange={handleRadioChange}
                                        /> 是
                                    </label>
                                    <label className="radio-inline">
                                        <input
                                            type="radio"
                                            name="e_material"
                                            value="false"
                                            checked={formData.e_material === false}
                                            onChange={handleRadioChange}
                                        /> 否
                                    </label>
                                </div>
                            </div>



                            {/* 匯款資訊 */}
                            {/* <div className="form-group mb-4">
                                <label className="mb-2">*匯款日期</label>
                                <input type="date" className="form-control" name="remittance_date" value={formData.remittance_date} onChange={(e) => setFormData({ ...formData, remittance_date: e.target.value })} required />
                            </div>

                            <div className="form-group mb-4">
                                <label className="mb-2">*匯款帳號後五碼</label>
                                <input type="text" className="form-control" name="remittance_last5" value={formData.remittance_last5} onChange={(e) => setFormData({ ...formData, remittance_last5: e.target.value })} maxLength="5" required />
                            </div> */}

                            {/* 申請點數 */}
                            <div className="form-group mb-4">
                                <label className="mb-2">*申請點數</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    name="requested_points"
                                    value={formData.requested_points}
                                    readOnly // 讓點數無法手動輸入
                                />
                                <small className="text-muted">系統根據選擇的學科 & 專科，自動計算所需點數</small>
                            </div>

                            {/* 提交按鈕 */}
                            <button type="submit" className="btn btn-primary w-100" disabled={isSubmitting}>
                                {isSubmitting ? "提交中..." : "提交申請"}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PointRequestForm;
